import { createFeatureSelector, createSelector } from '@ngrx/store';

import { BusinessState } from './business.models';
import { BUSINESS_FEATURE_KEY } from './business.reducer';

// Lookup the 'Business' feature state managed by NgRx
export const getBusinessState = createFeatureSelector<BusinessState>(BUSINESS_FEATURE_KEY);

export const getSelectedBusiness = createSelector(
  getBusinessState,
  (state: BusinessState) => state?.selectedBusiness,
);

export const selectVerifyData = createSelector(
  getBusinessState,
  (state: BusinessState) => state?.verifyData,
);
